<p
   [ngStyle]="{'background-color': (hoursRemaining === 0 && minutesRemaining <= 0) ? '#ffcccb' : ((hoursRemaining === 0 && minutesRemaining <= 10) ? 'orange' : 'transparent')}">
  <span id="clock">{{ 'candidate.exam.timeRemaining' | translate }}: {{ hoursRemaining }}h {{ minutesRemaining }}m
  </span>
</p>
